import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'

export enum SignificantDateCategoryId {
  PUBLIC_HOLIDAY = 1,
  NEARBY_EVENT = 2,
  OTHER = 3,
}

export class SignificantDateCategory extends Codebook<SignificantDateCategoryId> {
  static readonly PUBLIC_HOLIDAY = new SignificantDateCategory(
    SignificantDateCategoryId.PUBLIC_HOLIDAY,
    () => $t('Public holiday'),
  )
  static readonly NEARBY_EVENT = new SignificantDateCategory(
    SignificantDateCategoryId.NEARBY_EVENT,
    () => $t('Local event'),
  )
  static readonly OTHER = new SignificantDateCategory(SignificantDateCategoryId.OTHER, () =>
    $t('Other'),
  )

  private constructor(
    id: SignificantDateCategoryId,
    public readonly name: () => string,
  ) {
    super(id)
  }
}
